/**
 * Canonical service-order state keys as stored in `service.SVC_service_order.state`.
 * Shared between the filter-options response, request validation, and the domain query layer.
 */
export const SERVICE_ORDER_STATES = [
  'ARCHIVED',
  'CANCELLED',
  'CLOSED',
  'DRAFT',
  'INPROGRESS',
  'INVOICED',
  'LOCKED',
  'OFFER',
  'OPEN',
  'PAUSED',
  'PLANNED',
  'POSTPONED',
  'REQUEST',
  'WORKDONE',
] as const;

export type ServiceOrderState = (typeof SERVICE_ORDER_STATES)[number];
